"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_FIELD_INPUT = void 0;
const TEXT_FIELD_INPUT = exports.TEXT_FIELD_INPUT = 'text-field-input';
